import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_unified-calendar-app-2/artifacts/7wohqirg_Texto%20del%20pa%CC%81rrafo.jpeg";

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-[#F4EFE4]">
      <nav className="sticky top-0 z-50 backdrop-blur-md bg-[#F4EFE4]/90 border-b border-[#E8DFD2]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Amarme" className="h-10 w-10 rounded-full object-cover border border-[#B5704A]/20" />
            <div className="leading-none">
              <div className="brand-wordmark text-base text-[#3A2418]">AMARME</div>
              <div className="font-script text-xs text-[#B5704A] -mt-0.5">Skin studio</div>
            </div>
          </Link>
          <Link to="/" className="inline-flex items-center gap-1 text-sm text-[#6F5A4C] hover:text-[#B5704A]">
            <ArrowLeft className="w-4 h-4" /> Volver
          </Link>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 py-16 text-[#3A2418]">
        <span className="label-eyebrow text-[#B5704A]">Legal</span>
        <h1 className="font-display text-5xl font-[300] mt-2 leading-tight" data-testid="terms-title">
          Términos de <span className="italic font-[500] text-[#B5704A]">servicio</span>
        </h1>
        <p className="text-sm text-[#6F5A4C] mt-2">Última actualización: 27 de mayo de 2026</p>

        <div className="prose prose-stone mt-10 space-y-6 leading-relaxed">
          <p>
            Bienvenida a <strong>Amarme Skin Studio</strong>. Al reservar una cita o utilizar el sitio <strong>amarmeskin.cl</strong>, aceptas los siguientes términos. Te pedimos leerlos con atención.
          </p>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">1. Servicios ofrecidos</h2>
            <p>
              Amarme Skin Studio es un estudio de cosmetología facial profesional que ofrece tratamientos como Limpieza Facial Purificante, Ritual Hydraglow, Dermapen Regenerador y Peeling Renovador, entre otros. Todos los tratamientos son realizados por profesionales capacitadas y se personalizan según tu diagnóstico.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">2. Reservas</h2>
            <ul className="list-disc list-inside space-y-1 text-[#3A2418]">
              <li>Las reservas se realizan online en amarmeskin.cl o vía WhatsApp.</li>
              <li>Al reservar deberás completar tu ficha clínica con información veraz.</li>
              <li>La confirmación de la cita queda sujeta a la disponibilidad real del estudio.</li>
              <li>Sugerimos llegar 5 minutos antes de la hora reservada.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">3. Política de cancelaciones</h2>
            <ul className="list-disc list-inside space-y-1 text-[#3A2418]">
              <li>Puedes cancelar o reprogramar tu cita sin costo hasta <strong>24 horas antes</strong> de la hora reservada.</li>
              <li>Cancelaciones con menos de 24 horas o no presentarse (<em>no-show</em>) podrán implicar una penalización del 50% del valor del tratamiento en tu próxima visita.</li>
              <li>Las cancelaciones se realizan por WhatsApp al <a className="text-[#B5704A] underline" href="https://wa.me/56973842894">+56 9 7384 2894</a>.</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">4. Veracidad de la información clínica</h2>
            <p>
              Eres responsable de declarar de manera veraz y completa tu información médica (alergias, medicamentos, embarazo, cirugías, condiciones de la piel). Esta información es vital para tu seguridad y para diseñar el protocolo adecuado. Cualquier omisión exime al estudio de responsabilidad por reacciones derivadas.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">5. Resultados de los tratamientos</h2>
            <p>
              Los tratamientos estéticos pueden producir resultados variables según cada tipo de piel, hábitos personales (sol, tabaco, dieta), constancia y otros factores individuales. No garantizamos un resultado idéntico al de otras clientas. Los mejores resultados se obtienen con constancia y siguiendo nuestras recomendaciones de cuidado en casa.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">6. Cuidados post-tratamiento</h2>
            <p>
              Después de cada sesión recibirás indicaciones específicas. Es tu responsabilidad seguirlas (uso de protector solar, evitar exposición al sol, no aplicar productos irritantes, etc.). El estudio no se hace responsable por complicaciones derivadas del incumplimiento de estas indicaciones.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">7. Pagos</h2>
            <p>
              Los valores de los tratamientos son los vigentes al momento de la reserva e indicados en el estudio. Aceptamos efectivo, transferencia y los medios de pago indicados al momento de la cita.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">8. Confidencialidad</h2>
            <p>
              Toda tu información clínica y personal será tratada con absoluta reserva conforme a nuestra <Link to="/privacidad" className="text-[#B5704A] underline">Política de Privacidad</Link>.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">9. Imágenes y testimonios</h2>
            <p>
              No publicaremos imágenes ni testimonios tuyos sin tu autorización expresa. En caso de que aceptes compartir tu experiencia, podrás hacerlo de forma voluntaria por escrito.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">10. Modificaciones</h2>
            <p>
              Estos términos pueden actualizarse periódicamente. La fecha de la última actualización aparece al inicio del documento. Te recomendamos revisarlos cuando agendes una nueva sesión.
            </p>
          </section>

          <section>
            <h2 className="font-display text-2xl font-[600] text-[#3A2418] mt-8 mb-3">11. Contacto</h2>
            <p>
              <strong>Amarme Skin Studio</strong><br />
              WhatsApp: <a className="text-[#B5704A] underline" href="https://wa.me/56973842894">+56 9 7384 2894</a><br />
              Instagram: <a className="text-[#B5704A] underline" href="https://www.instagram.com/amarmeskin">@amarmeskin</a><br />
              Web: <a className="text-[#B5704A] underline" href="https://amarmeskin.cl">amarmeskin.cl</a>
            </p>
          </section>
        </div>
      </article>
    </div>
  );
}
